export interface DailyPuzzlePickerGame {
  slug: string;
  name: string;
  thumbnail_url: string;
}

/**
 * Catalog fallbacks so the chooser still renders if homepage data
 * does not include these slugs (tests, empty catalog, fetch failure).
 */
export const DAILY_PUZZLE_PICKER_FALLBACKS: DailyPuzzlePickerGame[] = [
  {
    slug: "crossyblock-math-daily",
    name: "CrossyBlock Math Daily",
    thumbnail_url:
      "https://assets.playmath.org/game-catalog/icons/crossyblock-math-daily-1787262238249.webp",
  },
  {
    slug: "mystery-grid",
    name: "Mystery Grid",
    thumbnail_url: "https://assets.playmath.org/game-catalog/icons/mystery-grid-1787214265546.webp",
  },
];

export function isDailyPuzzlePickerSlug(slug: string): boolean {
  return DAILY_PUZZLE_PICKER_FALLBACKS.some((game) => game.slug === slug);
}

export function mergeDailyPuzzlePickerGames(
  live: Array<{ slug: string; name?: string | null; thumbnail_url?: string | null }>
): DailyPuzzlePickerGame[] {
  return DAILY_PUZZLE_PICKER_FALLBACKS.map((fallback) => {
    const found = live.find((game) => game.slug === fallback.slug);
    if (!found) return fallback;
    return {
      slug: fallback.slug,
      name: found.name?.trim() || fallback.name,
      thumbnail_url: found.thumbnail_url?.trim() || fallback.thumbnail_url,
    };
  });
}
